import { useState, useEffect } from 'react';

export const useWindowSize = () => {
    const [windowSize, setSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight
    });

    const resize = () => {
        setSize({
            width: window.innerWidth,
            height: window.innerHeight
        })
    };

    useEffect(() => {
        window.addEventListener('resize', resize);
        return () => {
            window.removeEventListener('resize', resize);
        };
    }, []);

    return { windowSize };
}